import { LOGO_URL } from "../data/caseStudies";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 bg-[#050505] mt-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3 mb-5">
            <img
              src={LOGO_URL}
              alt="LinkSync"
              className="w-10 h-10 rounded-lg object-cover border border-white/10"
            />
            <span className="font-serif-display text-2xl">LinkSync</span>
          </div>
          <p className="text-white/60 text-sm max-w-sm leading-relaxed">
            Agence d'influence. Nous aidons les produits à trouver leur audience
            et à transformer la notoriété en revenus mesurables.
          </p>
        </div>

        <div className="md:col-span-5">
          <div className="ls-overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li>
              <a
                href="mailto:contact@linksync.fr"
                data-testid="footer-email"
                className="ls-link"
              >
                contact@linksync.fr
              </a>
            </li>
            <li>
              <a
                href="https://linksync.fr"
                className="ls-link"
                target="_blank"
                rel="noreferrer"
              >
                linksync.fr
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>
            © {new Date().getFullYear()} LinkSync — Tous droits réservés
          </div>
          <div className="ls-overline">Paris · Remote</div>
        </div>
      </div>
    </footer>
  );
}
